import { forwardRef } from "react"

import clsx from "clsx"

import styles from "./modal-trigger-button.module.scss"

interface ModalTriggerButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean
}

export const ModalTriggerButton = forwardRef<HTMLButtonElement, ModalTriggerButtonProps>(
  ({ isActive = false, className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label="Открыть"
      className={clsx(styles.button, isActive && styles.active, className)}
      {...props}
    >
      <div className={styles.point} />
    </button>
  ),
)

ModalTriggerButton.displayName = "ModalTriggerButton"
